/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { cva } from "@panda/css";
import { Grid } from "@panda/jsx";

import { CruxLink } from "./CruxLink.molecule";
import { RecipeVariantProps } from "@panda/types";
import { CruxLinkFragment } from "@cosmos/hygraph-schema";

const linkGrid = cva({
	base: {
		"&&": {
			gap: "eds.dimension.16",
		},
	},
	variants: {
		links: {
			1: {
				gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
			},
			2: {
				gridTemplateColumns: {
					base: "repeat(2, minmax(0, 1fr))",
					mdDown: "repeat(1, minmax(0, 1fr))",
				},
			},
			3: {
				gridTemplateColumns: {
					base: "repeat(3, minmax(0, 1fr))",
					mdDown: "repeat(1, minmax(0, 1fr))",
				},
			},
			4: {
				gridTemplateColumns: {
					base: "repeat(2, minmax(0, 1fr))",
					mdDown: "repeat(1, minmax(0, 1fr))",
				},
			},
		},
	},
	defaultVariants: {
		links: 4,
	},
});

export type CruxLinksProps = {
	links?: CruxLinkFragment[];
};

export function CruxLinks({ links }: CruxLinksProps): React.JSX.Element {
	const linkCount = links?.length ?? 0;
	return (
		<Grid className={linkGrid({ links: linkCount } as RecipeVariantProps<typeof linkGrid>)}>
			{links?.map((link, i) => (
				<CruxLink key={`crux-link-${i}`} {...link} />
			))}
		</Grid>
	);
}
